import { urlGlobal2 } from './GlobalService.js';

export const buscarSolicitud360 = async(params=null, idPago) =>{
    let url = new URL(`${urlGlobal2}/pagos360/encontrarPago/${idPago}`)
    if (params != null) {
        url.search = new URLSearchParams(params).toString();
    }
    try{
        let token = localStorage.getItem('token');
        let headers = {'Content-Type':'application/json', token}
        let method = 'GET';
        let resp = await fetch(url,{method, headers});
        let data = await resp.json();
        return data;
    }
    catch(error){
        alert(error.message);
        return null;
    }
}
export const getIdFromBarcode=(barcode)=>{
    if(barcode.length != 44){
      alert('El codigo de barra no tiene 44 caracteres');
      return null;
    }

    return barcode.substr(15,7);
  
  }